import { Typography } from '@ui/components';
import React from 'react';

interface DashboardContentPlaceholderProps extends React.ComponentPropsWithoutRef<'div'> {
  title: string;
  icon: React.ReactNode;
}

export const DashboardContentPlaceholder = (props: DashboardContentPlaceholderProps) => {
  const { title, icon, ...rest } = props;

  const iconWithClassName = React.isValidElement(icon)
    ? React.cloneElement(icon as React.ReactElement<{ className?: string }>, {
        className:
          `size-12 ${(icon as React.ReactElement<{ className?: string }>).props.className || ''}`.trim(),
      })
    : icon;

  return (
    <div className="flex justify-center items-center h-full" {...rest}>
      <div className="flex flex-col items-center gap-6 -mt-10">
        {/* I've used text-[#CDCBD3] color for placeholder icon because it's the only place where it's used and it's not defined in the theme in figma */}
        <div className="flex items-center justify-center bg-surface-hover text-[#CDCBD3] size-18 rounded-full">
          {iconWithClassName}
        </div>

        <Typography variant="labelMediumMedium" className="text-weak">
          {title}
        </Typography>
      </div>
    </div>
  );
};
